// Bounding boxes for countries [west, south, east, north]
// Used to restrict geocoding results to the user's country
export const COUNTRY_BOUNDING_BOXES: Record<string, { bbox: string; label: string }> = {
  DE: { bbox: '5.87,47.27,15.04,55.06', label: 'Deutschland' },
  AT: { bbox: '9.53,46.37,17.16,49.02', label: 'Österreich' },
  CH: { bbox: '5.96,45.82,10.49,47.81', label: 'Schweiz' },
  GB: { bbox: '-8.65,49.86,1.77,60.86', label: 'United Kingdom' },
  FR: { bbox: '-5.14,41.36,9.56,51.09', label: 'France' },
  ES: { bbox: '-9.39,36.00,3.35,43.79', label: 'España' },
  IT: { bbox: '6.63,36.62,18.52,47.09', label: 'Italia' },
  NL: { bbox: '3.36,50.75,7.21,53.47', label: 'Nederland' },
  PL: { bbox: '14.12,49.00,24.15,54.84', label: 'Polska' },
  CZ: { bbox: '12.09,48.55,18.86,51.06', label: 'Česko' },
  SK: { bbox: '16.84,47.73,22.57,49.61', label: 'Slovensko' },
};

// Map language code to country code
export const languageToCountryCode = (lang: string): string => {
  const map: Record<string, string> = {
    de: 'DE',
    en: 'GB',
    fr: 'FR',
    es: 'ES',
    it: 'IT',
    nl: 'NL',
    pl: 'PL',
    cs: 'CZ',
    sk: 'SK',
  };
  return map[lang] || 'DE';
};

export const getBboxForCountry = (countryCode: string): string => {
  return COUNTRY_BOUNDING_BOXES[countryCode]?.bbox || COUNTRY_BOUNDING_BOXES.DE.bbox;
};

export const getCountryLabelForSearch = (countryCode: string): string => {
  return COUNTRY_BOUNDING_BOXES[countryCode]?.label || 'Deutschland';
};
